import * as SeparatorPrimitive from '@radix-ui/react-separator';
import * as React from 'react';

import { FLEX_SHRINK } from '@/components/design-system/tokens';
import { cn } from '@/lib/utils';

interface SeparatorProps extends React.ComponentPropsWithoutRef<typeof SeparatorPrimitive.Root> {
  orientation?: 'horizontal' | 'vertical';
}

const Separator = React.forwardRef<
  React.ElementRef<typeof SeparatorPrimitive.Root>,
  SeparatorProps
>(({ className, orientation = 'horizontal', decorative = true, ...props }, ref) => (
  <SeparatorPrimitive.Root
    ref={ref}
    decorative={decorative}
    orientation={orientation}
    className={cn(
      FLEX_SHRINK[0],
      'bg-border',
      orientation === 'horizontal'
        ? 'h-[var(--border-width-thin)] w-full'
        : 'h-full w-[var(--border-width-thin)]',
      className
    )}
    {...props}
  />
));
Separator.displayName = SeparatorPrimitive.Root.displayName;

export { Separator };
